if (!customElements.get('bozhi-carousel')) {
  customElements.define('bozhi-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.bozhi-carousel__track');
      if (!track) return;
      const buttons = this.querySelectorAll('[data-direction]');
      const update = () => buttons.forEach(button => {
        button.disabled = Number(button.dataset.direction) < 0 ? track.scrollLeft <= 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
      buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({left:Number(button.dataset.direction) * track.clientWidth * .8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}), {signal}));
      track.addEventListener('scroll', update, {passive:true,signal});
      this.querySelectorAll('video').forEach((video,index) => {
        video.setAttribute('aria-label', `${this.querySelector('h2')?.textContent || 'Bozhi'} ${index + 1}`);
        video.addEventListener('play', () => this.querySelectorAll('video').forEach(other => {if(other!==video) other.pause();}),{signal});
      });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();this.querySelectorAll('video').forEach(video=>video.pause());}
  });
}

/* Fit mobile product galleries to each visible image without changing desktop layouts. */
(() => {
  if (window.__bozhiMobileGalleryFit) return;
  window.__bozhiMobileGalleryFit = true;
  const instances = new Map();
  function mount(gallery) {
    if (instances.has(gallery)) return;
    const mobile = window.matchMedia('(max-width: 749px)');
    let frame = 0;
    function update() {
      frame = 0;
      if (!gallery.isConnected) { destroy(); return; }
      const track = gallery.querySelector('[id^="Slider-Gallery-"]');
      if (!track) return;
      if (!mobile.matches) { track.style.removeProperty('--bozhi-active-media-height'); return; }
      const left = track.getBoundingClientRect().left;
      const slides = Array.from(track.children).filter(slide => slide.matches('.product__media-item') && slide.getBoundingClientRect().width > 0);
      const active = slides.reduce((best, slide) => !best || Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(best.getBoundingClientRect().left - left) ? slide : best, null);
      const media = active?.querySelector('.product-media-container');
      if (!media) return;
      const height = Math.ceil(media.getBoundingClientRect().height);
      if (height > 0 && track.style.getPropertyValue('--bozhi-active-media-height') !== `${height}px`) {
        track.style.setProperty('--bozhi-active-media-height', `${height}px`);
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    const changes = new MutationObserver(schedule);
    changes.observe(gallery, {childList:true,subtree:true,attributes:true,attributeFilter:['class','aria-current']});
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    resize?.observe(gallery);
    gallery.addEventListener('scroll', schedule, {capture:true,passive:true});
    gallery.addEventListener('load', schedule, true);
    gallery.addEventListener('loadedmetadata', schedule, true);
    gallery.addEventListener('slideChanged', schedule);
    mobile.addEventListener('change', schedule);
    window.addEventListener('resize', schedule, {passive:true});
    function destroy() {
      cancelAnimationFrame(frame);
      changes.disconnect();
      resize?.disconnect();
      gallery.removeEventListener('scroll', schedule, true);
      gallery.removeEventListener('load', schedule, true);
      gallery.removeEventListener('loadedmetadata', schedule, true);
      gallery.removeEventListener('slideChanged', schedule);
      mobile.removeEventListener('change', schedule);
      window.removeEventListener('resize', schedule);
      instances.delete(gallery);
    }
    instances.set(gallery, destroy);
    schedule();
  }
  function scan() {
    instances.forEach((destroy, gallery) => { if (!gallery.isConnected) destroy(); });
    document.querySelectorAll('body.bozhi-template-product media-gallery').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, gallery) => { if (event.target.contains(gallery)) destroy(); });
  });
})();
